import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren, ReactNode } from 'react';
import { Badge } from '@repo/ui';
import { Avatar } from '../Avatar';
interface OptionLabelProps extends PropsWithChildren {
  imgUrl?: string;
  icon?: ReactNode;
  tag?: string;
}
export function OptionLabel(t0) {
  const $ = _c(9);
  const {
    imgUrl,
    icon,
    tag,
    children
  } = t0;
  let t1;
  if ($[0] !== icon || $[1] !== imgUrl) {
    t1 = icon ? <Avatar icon={icon} size="small" className="mr-2xs" /> : imgUrl && <Avatar src={imgUrl} size="small" className="mr-2xs" />;
    $[0] = icon;
    $[1] = imgUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== tag) {
    t2 = tag && <Badge variant="info" size="sm" className="ml-xs">{tag}</Badge>;
    $[3] = tag;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t1 || $[7] !== t2) {
    t3 = <span className="flex items-center">{t1}{children}{t2}</span>;
    $[5] = children;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}